module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/120-bahamas-e995e2ada5290e79dfe3a945b36731e7.svg";